<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
        {{ userCompany }} employees shall remain awake and alert at all
        times while on shift at any location. Employees may not sleep
        while on shift at any location. Any sleeping during any shift will
        not be tolerated without exception. Sleeping on shift in any of the
        following positions is against policy:on a chair, learning over a desk,
        head resting on an object, lying on a bed,couch, floor, table, learning
        against a wall, and any other position that does not allow for complete
        supervision of clients.
        </p>
        <p class="text-caption">
        Sleeping on shift is neglect (failure to provide adequate client supervision,
        including situations where the employee is asleep or ill on the job,
        or is impaired due to the use of alcohol or drugs.) Neglect will be
        reported to APS or CPS and /or the local law enforcement agency. Violation of
        this policy will result in an adjustment and 3 adjusments of this policy will result
        in termination from the company.
        </p>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInAwakePolicy"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedEmployeeInAwakePolicy"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedEmployeeInAwakePolicy"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
        <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      showSignaturePad: false,
      employeeSignatureInAwakePolicy: "",
       item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInAwakePolicy");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInAwakePolicy = data;
      localStorage.setItem("employeeSignatureInAwakePolicy", data);
    },

    next() {
      this.addItem();

      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
     prev() {
      this.$emit("clicked", this.step - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('dateSignedEmployeeInAwakePolicy', this.dateSignedEmployeeInAwakePolicy);

      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const dateSignedForEmployee = localStorage.getItem('dateSignedEmployeeInAwakePolicy');

      if (dateSignedForEmployee !== null) {
         this.dateSignedEmployeeInAwakePolicy= dateSignedForEmployee;
      }


      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
